import React, { useEffect, useRef, useState } from "react"
import LeftIcon from "../../images/LeftIcon"
import DatePicker from "react-datepicker";
import { reloadHeader, webLoadingFalse, webLoadingTrue, webNavigate } from "../../services/navigate.service"
import { createSales } from "../../services/sales.service"
import { validateEmail, validateNoSpecialChars, validateNoSpecialCharsOrSpaces, validateOnlyNumbers, validateOnlyNumbersNotThree, validatePhoneNumber } from "../../validation/ValidationInput"
import ArrowClientsIcon from "../../images/ArrowClientsIcon"
import TableReport from "../../components/TableReport"
import { loadTerm } from "../../services/term.service"
import { getCountries } from "../../services/country.service";
import { createLocations, getDetailLocations, updateLocations } from "../../services/locations.services";
import PopupLocation from "../../components/PopupLocation";
import BackIcon from "../../images/BackIcon";
import { useResponsive } from "../../hook/useResponsive";
import { showToast } from "../../services/toast.service";
import { showApiError } from "../../services/apiError";
import { coreFormLimits, limitProps, useFieldLimits, validateAgainstLimits } from "../../services/fieldLimits";
import FieldCounter from "../../components/FieldCounter";
import { useFormKeyboard } from "../../hook/useFormKeyboard";
interface InforTable {
    title: string;
    path: string;
    desc: string;
    titleCreate: string;
}

interface Country {
    id: string;
    code: string;
    name: string;
}

const LocationCompany = () => {
    const preLanguage = localStorage.getItem("language");
    const [formValues, setFormValues] = useState<any>({
        locationCode: '',
        address: "",
        manager: "",
        name: '',
        unitNumber: '',
        phoneNumber: '',
        city: '',
        internalName: '',
        email: '',
    });
    const [language, setLanguage] = useState<any>(null);
    const { isMobile, getWidth } = useResponsive();
    const [errors, setErrors] = useState<any>({});
    const limits = useFieldLimits(coreFormLimits("location"));
    const [tab, setTab] = useState<string>("profile");
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const [clientsArray, setClientsArray] = useState<any>({
        count: 0,
        data: []
    });
    const [filter, setFilter] = useState<any>({
        page: 1,
        limit: 50,
        sort: "DESC"
    })
    const [countries, setCountries] = useState<Country[]>([]);
    const [searchCountry, setSearchCountry] = useState("");
    const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
    const [countryHighlight, setCountryHighlight] = useState(-1);
    const dropdownCountryRef = useRef<HTMLDivElement>(null);
    const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
    const calculatedWidth = (windowWidth / 1290);
    const inforTable: InforTable = {
        title: "No Location Found", path: "/locations/new", desc: "Add a new employee to manage your team here.", titleCreate: "New Employee"
    }
    const path = window.location.pathname;
    const id: string = path.split('/').pop() || "";
    const kb = useFormKeyboard({ autoFocus: id === "new" && !isMobile });
    const handleClosePopup = () => {
        setShowPopup(false);
    };
    const handleOpenPopup = () => {
        setShowPopup(true);
    };
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownCountryRef.current && !dropdownCountryRef.current.contains(event.target as Node)) {
                setIsCountryDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    useEffect(() => {
        if (id !== "new") {
            fetchData(id);
        }
        const handleNewToken = () => {
            if (id !== "new") {
                fetchData(id);
            }
        };
        document.addEventListener("newToken", handleNewToken);
        return () => {
            document.removeEventListener("newToken", handleNewToken);
        };
    }, [path]);
    const fetchData = async (id: string) => {
        webLoadingTrue();
        try {
            const response: any = await getDetailLocations(id);
            console.log("🚀 ~ fetchData ~ response:", response)
            setFormValues(response.data);
            setSearchCountry(response.data.country.countryName);
        } catch (error) {
            console.error("Error loading terms:", error);
        } finally {
            webLoadingFalse();
        }
    };
    useEffect(() => {
        const fetchCountries = async () => {
            const data = await getCountries();
            setCountries(data);
        };
        fetchCountries();
        const handleNewToken = async () => {
            const data = await getCountries();
            setCountries(data);
        };
        document.addEventListener("newToken", handleNewToken);
        return () => {
            document.removeEventListener("newToken", handleNewToken);
        };
    }, []);

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
        const { name, value, type } = e.target;
        setFormValues({ ...formValues, [name]: value })
    }
    useEffect(() => {
        if (window.languageContext) {
            setLanguage(window.languageContext.language);
        }
    }, [window, window.languageContext]);

    const handleCountrySelect = (countryId: string, countryName: string) => {
        setFormValues((prev: any) => ({ ...prev, city: countryId }));
        setSearchCountry(countryName);
        setIsCountryDropdownOpen(false);
    };

    const handleSubmit = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        const newErrors: any = validateAgainstLimits(formValues, limits, language);
        if (!formValues.locationCode) {
            newErrors.locationCode = 'Code is required';
        }
        if (!formValues.name) {
            newErrors.name = 'Name is required';
        }
        if (!formValues.unitNumber) {
            newErrors.unitNumber = 'Unit Number is required';
        }
        if (!formValues.city) {
            newErrors.city = 'Country is required';
        }
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        webLoadingTrue();
        try {
            if (id === "new") {
                const response = await createLocations(formValues);
                if (response?.data?.id) {
                    webNavigate("/" + preLanguage + "/companies" + "?tab=location");
                    showToast({
                        message: "Location added successfully !",
                        type: "success",
                        duration: 20000,
                    });
                    reloadHeader(true)
                    webLoadingFalse();
                } else {
                    handleOpenPopup();
                    webLoadingFalse();
                    showToast({
                        message: language?.["Create Location Failed"] ?? "Create Location Failed",
                        type: "error",
                        duration: 20000,
                    });
                }
            } else {
                const payload: any = {
                    address: formValues.address,
                    city: formValues.city,
                    email: formValues.email,
                    internalName: formValues.internalName,
                    locationCode: formValues.locationCode,
                    manager: formValues.manager,
                    name: formValues.name,
                    phoneNumber: formValues.phoneNumber,
                    unitNumber: formValues.unitNumber,
                }
                const response = await updateLocations(id, payload);
                if (response?.data?.id) {
                    webNavigate("/" + preLanguage + "/companies" + "?tab=location");
                    showToast({
                        message: "Location added successfully !",
                        type: "success",
                        duration: 20000,
                    });
                    webLoadingFalse();
                } else {
                    handleOpenPopup();
                    webLoadingFalse();
                    showToast({
                        message: language?.["Update Location Failed"] ?? "Update Location Failed",
                        type: "error",
                        duration: 20000,
                    });
                }
            }
        } catch (error: any) {
            handleOpenPopup();
            showApiError(error, { language, setFieldErrors: setErrors });
        } finally {
            webLoadingFalse();
        }
    }

    const handleReceivePageNumber = (pageNumber: number) => {
        setFilter({ ...filter, page: pageNumber })
    }
    const filteredCountries = isCountryDropdownOpen
        ? countries.filter(country =>
            country.name.toLowerCase().includes(searchCountry.toLowerCase())
        )
        : [];
    // Enter saves only when the closed list's text names the selected country; otherwise it picks
    // (highlight, exact name, lone prefix match) or keeps the list open. Tab picks, Escape closes.
    const handleCountryKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const { key } = e;
        const highlighted = filteredCountries[countryHighlight];
        const typed = searchCountry.trim().toLowerCase();
        const exact = countries.find(country => country.name.trim().toLowerCase() === typed);
        if (key === 'ArrowDown' || key === 'ArrowUp') {
            e.preventDefault();
            if (!isCountryDropdownOpen) {
                setCountryHighlight(-1);
                setIsCountryDropdownOpen(true);
                return;
            }
            setCountryHighlight(i => key === 'ArrowDown' ? Math.min(filteredCountries.length - 1, i + 1) : Math.max(0, i - 1));
        } else if (key === 'Enter' && !e.ctrlKey && !e.metaKey) {
            const selectedName = countries.find(country => country.id === formValues?.city)?.name ?? formValues?.country?.countryName ?? '';
            if (!isCountryDropdownOpen && typed === selectedName.trim().toLowerCase()) return;
            e.preventDefault();
            const lone = filteredCountries.length === 1 && filteredCountries[0].name.toLowerCase().startsWith(typed) ? filteredCountries[0] : undefined;
            const match = highlighted ?? exact ?? lone;
            if (match) handleCountrySelect(match.id, match.name);
            else {
                setCountryHighlight(-1);
                setIsCountryDropdownOpen(true);
            }
        } else if (key === 'Escape' && isCountryDropdownOpen) {
            e.preventDefault();
            e.stopPropagation();
            setIsCountryDropdownOpen(false);
        } else if (key === 'Tab' && isCountryDropdownOpen) {
            const match = highlighted ?? exact;
            if (match) handleCountrySelect(match.id, match.name);
            else setIsCountryDropdownOpen(false);
        }
    };

    return (
        <div {...kb.scopeProps}>
            <div className="bg-white">
                <div className="flex items-center ">
                    <button
                        type="button"
                        aria-label={language?.['Back'] ?? 'Back'}
                        className="w-6 h-6 flex items-center justify-center cursor-pointer"
                        onClick={() => { webNavigate("/" + preLanguage + "/companies" + "?tab=location") }}
                    >
                        <BackIcon />
                    </button>
                    <p
                        style={{ fontSize: '14px', fontWeight: '500', lineHeight: '28px', color: '#222525' }}
                        className="font-inter"
                    >
                        {language && language?.['Back'] ? language?.['Back'] : 'Back'}
                    </p>
                </div>
            </div>
            {
                id === "new" ?
                    <p
                        style={{
                            margin: '20px 0px',
                            fontSize: '20px',
                            fontWeight: '500',
                            lineHeight: '28px',
                            color: '#222525',
                        }}
                        className="font-inter"
                    >
                        {language && language?.[`Add location details`] ? language?.[`Add location details`] : `Add location details`}
                    </p>
                    :
                    <p
                        style={{
                            margin: '20px 0px',
                            fontSize: '20px',
                            fontWeight: '500',
                            lineHeight: '28px',
                            color: '#222525',
                        }}
                        className="font-inter"
                    >
                        {language && language?.[`Edit location details`] ? language?.[`Edit location details`] : `Edit location details`}
                    </p>
            }
            {/* <div className="flex items-center" style={{ marginTop: "24px", borderBottom: "1px solid #DEDEE2" }}>
                <p className="text-[14px] font-inter leading-[21px] font-medium cursor-pointer" onClick={() => { setTab("profile") }}
                    style={tab === "profile" ? { marginRight: "24px", color: "#078D91", borderBottom: "1px solid #078D91" } : { marginRight: "24px", color: "#767685", borderBottom: "1px solid transparent" }} >Profile</p>
                <p className="text-[14px] font-inter leading-[21px] font-medium cursor-pointer" onClick={() => { setTab("invoices") }}
                    style={tab === "invoices" ? { color: "#078D91", borderBottom: "1px solid #078D91" } : { color: "#767685", borderBottom: "1px solid transparent" }} >Invoices</p>
            </div> */}
            <div className="scroll-container" style={{ height: 'calc(100% - 160px)', overflowY: 'scroll' }}>
                {tab === "profile" ?
                    <>
                        <form >
                            <div className="flex items-center" style={{ gap: '24px', flexWrap: 'wrap' }}>
                                <div style={{ width: isMobile ? "calc(50% - 12px)" : "calc(33% - 12px)" }} className="space-y-2">
                                    <div className="flex items-center">
                                        <p className="text-[14px] font-inter leading-[20px] font-medium" style={{ color: "#4A5353" }}>{language && language?.["Code"] ? language?.["Code"] : "Code"}</p>
                                        <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#BA0E13' }}>
                                            {language && language?.['*'] ? language?.['*'] : '*'}
                                        </p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            value={formValues?.locationCode}
                                            name="locationCode"
                                            {...limitProps(limits, "locationCode")}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                        <FieldCounter value={formValues?.locationCode} max={limits.locationCode?.maxLength} />
                                    </div>
                                    {errors.locationCode && <p className="error">{errors.locationCode}</p>}
                                </div>
                                <div className="space-y-2" style={{ width: isMobile ? "calc(50% - 12px)" : "calc(33% - 12px)" }}>
                                    <div className="flex items-center ">
                                        <p className="text-[14px] font-inter leading-[20px] font-medium" style={{ color: "#4A5353" }}>{language && language?.["Name"] ? language?.["Name"] : "Name"}</p>
                                        <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#BA0E13' }}>
                                            {language && language?.['*'] ? language?.['*'] : '*'}
                                        </p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            type="text"
                                            name="name"
                                            {...limitProps(limits, "name")}
                                            value={formValues?.name}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                        <FieldCounter value={formValues?.name} max={limits.name?.maxLength} />
                                    </div>
                                    {errors.name && <p className="error">{errors.name}</p>}
                                </div>
                                <div className="w-full space-y-2" style={{ width: isMobile ? "100%" : "calc(33% - 12px)" }}>
                                    <div className="flex items-center">
                                        <p className="text-[14px] font-inter leading-[20px] font-medium" style={{ color: "#4A5353" }}>{language && language?.["Country"] ? language?.["Country"] : "Country"}</p>
                                        <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#BA0E13' }}>
                                            {language && language?.['*'] ? language?.['*'] : '*'}
                                        </p>
                                    </div>
                                    <div className="relative" ref={dropdownCountryRef}>
                                        <input
                                            type="text"
                                            value={searchCountry}
                                            role="combobox"
                                            aria-expanded={isCountryDropdownOpen}
                                            aria-autocomplete="list"
                                            onChange={(e) => {
                                                setSearchCountry(e.target.value);
                                                setCountryHighlight(-1);
                                                setIsCountryDropdownOpen(true);
                                            }}
                                            onClick={() => {
                                                setCountryHighlight(-1);
                                                setIsCountryDropdownOpen(true);
                                            }}
                                            onKeyDown={(e) => {
                                                validateNoSpecialChars(e);
                                                handleCountryKeyDown(e);
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                        {errors.city && <p className="error">{errors.city}</p>}
                                        {isCountryDropdownOpen && (
                                            <div className="absolute z-10 w-full mt-1 bg-white border border-[#EBEBED] rounded-md shadow-lg max-h-60 overflow-auto">
                                                {filteredCountries
                                                    .map((country, index) => (
                                                        <div
                                                            key={country.id}
                                                            ref={index === countryHighlight ? (el) => el?.scrollIntoView({ block: 'nearest' }) : undefined}
                                                            className="px-4 py-2 cursor-pointer hover:bg-[#E7F1F1] text-main"
                                                            style={index === countryHighlight ? { backgroundColor: '#E7F1F1' } : undefined}
                                                            onMouseDown={(e) => e.preventDefault()}
                                                            onClick={() => handleCountrySelect(country.id, country.name)}
                                                        >
                                                            {country.name}
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-2" style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}>
                                    <div className="flex items-center justify-between">
                                        <p className="text-[14px] font-inter leading-[20px] font-medium" style={{ color: "#4A5353" }}>{language && language?.["Address"] ? language?.["Address"] : "Address"}</p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            value={formValues?.address}
                                            onKeyDown={validateNoSpecialChars}
                                            name="address"
                                            {...limitProps(limits, "address")}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                        <FieldCounter value={formValues?.address} max={limits.address?.maxLength} />
                                    </div>
                                    {errors.address && <p className="error">{errors.address}</p>}
                                </div>
                                <div className="space-y-2" style={{ width: "calc(50% - 12px)" }}>
                                    <div className="flex items-center">
                                        <p className="text-[14px] font-inter leading-[20px] font-medium" style={{ color: "#4A5353" }}>{language && language?.["Unit Number"] ? language?.["Unit Number"] : "Unit Number"}</p>
                                        <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#BA0E13' }}>
                                            {language && language?.['*'] ? language?.['*'] : '*'}
                                        </p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            type="text"
                                            name="unitNumber"
                                            {...limitProps(limits, "unitNumber")}
                                            value={formValues?.unitNumber}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                        <FieldCounter value={formValues?.unitNumber} max={limits.unitNumber?.maxLength} />
                                    </div>
                                    {errors.unitNumber && <p className="error">{errors.unitNumber}</p>}
                                </div>
                                <div className="space-y-2" style={{ width: isMobile ? "calc(50% - 12px)" : "calc(33% - 12px)" }}>
                                    <div className="flex items-center justify-between">
                                        <p className="text-[14px] font-inter leading-[20px] font-medium" style={{ color: "#4A5353" }}>{language && language?.["Internal Name"] ? language?.["Internal Name"] : "Internal Name"}</p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            type="text"
                                            name="internalName"
                                            {...limitProps(limits, "internalName")}
                                            value={formValues?.internalName}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                        <FieldCounter value={formValues?.internalName} max={limits.internalName?.maxLength} />
                                    </div>
                                    {errors.internalName && <p className="error">{errors.internalName}</p>}
                                </div>
                                <div className="space-y-2" style={{ width: isMobile ? "100%" : "calc(33% - 12px)" }}>
                                    <div className="flex items-center justify-between">
                                        <p className="text-[14px] font-inter leading-[20px] font-medium" style={{ color: "#4A5353" }}>{language && language?.["Manager"] ? language?.["Manager"] : "Manager"}</p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            value={formValues?.manager}
                                            name="manager"
                                            {...limitProps(limits, "manager")}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                        <FieldCounter value={formValues?.manager} max={limits.manager?.maxLength} />
                                    </div>
                                    {errors.manager && <p className="error">{errors.manager}</p>}
                                </div>
                                <div className="space-y-2" style={{ width: isMobile ? "100%" : "calc(33% - 12px)" }}>
                                    <div className="flex items-center justify-between">
                                        <p className="text-[14px] font-inter leading-[20px] font-medium" style={{ color: "#4A5353" }}>{language && language?.["Phone Number"] ? language?.["Phone Number"] : "Phone Number"}</p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            type="text"
                                            name="phoneNumber"
                                            {...limitProps(limits, "phoneNumber")}
                                            onKeyDown={validatePhoneNumber}
                                            value={formValues?.phoneNumber}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                        <FieldCounter value={formValues?.phoneNumber} max={limits.phoneNumber?.maxLength} />
                                    </div>
                                    {errors.phoneNumber && <p className="error">{errors.phoneNumber}</p>}
                                </div>
                                <div className="space-y-2" style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}>
                                    <div className="flex items-center justify-between">
                                        <p className="text-[14px] font-inter leading-[20px] font-medium" style={{ color: "#4A5353" }}>{language && language?.["Email"] ? language?.["Email"] : "Email"}</p>
                                    </div>
                                    <div className="w-full">
                                        <input
                                            type="text"
                                            name="email"
                                            {...limitProps(limits, "email")}
                                            value={formValues?.email}
                                            onChange={(e: any) => {
                                                handleChange(e)
                                            }}
                                            className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                        />
                                        <FieldCounter value={formValues?.email} max={limits.email?.maxLength} />
                                    </div>
                                    {errors.email && <p className="error">{errors.email}</p>}
                                </div>
                            </div>
                        </form>
                        <PopupLocation show={showPopup} title={`${id === 'new' ? (language && language?.["Create Location"]) ? language?.["Create Location"] : "Create Location" : language && language?.["Update Location"] ? language?.["Update Location"] : "Update Location"}`} desc={`${id === 'new' ? (language && language?.["Create Location Failed"]) ? language?.["Create Location Failed"] : "Create Location Failed" : language && language?.["Update Location Failed"] ? language?.["Update Location Failed"] : "Update Location Failed"}`} onClose={handleClosePopup} onOpen={handleOpenPopup} />
                    </>
                    :
                    <>
                        {/* <TableReport data_table={clientsArray.data} count={clientsArray.count} titleCreate={inforTable} handleSendPageNumber={handleReceivePageNumber} /> */}
                    </>
                }
            </div>
            <div
                className="w-full flex items-center justify-end shadow_button relative"
                style={{ gap: "12px", paddingTop: "24px", }}
            >
                <div className="absolute" style={{ left: "-24px", top: 0, height: "1px", backgroundColor: "#DBE4E4", width: isMobile ? 'calc(100vw + 32px)' : "calc(-256px + 48px + 100vw)" }}></div>
                <button
                    type="button"
                    onClick={() => { webNavigate("/" + preLanguage + "/companies" + "?tab=location") }}
                    style={{
                        padding: '10px 24px',
                        borderRadius: '30px',
                        color: '#222525',
                        fontSize: '14px',
                        fontWeight: '500',
                        border: '1px solid #C9D7D8',
                    }}
                    className="font-inter cursor-pointer"
                >
                    {language && language?.['Cancel'] ? language?.['Cancel'] : 'Cancel'}
                </button>
                <button type="button" {...kb.primaryProps(handleSubmit)} style={{
                    padding: '10px 24px',
                    borderRadius: '30px',
                    color: '#FFFFFF',
                    fontSize: '14px',
                    fontWeight: '500',
                    backgroundColor: '#0F7679',
                }}
                    className="font-inter cursor-pointer"
                >
                    <p className="text-[14px] leading-[22px] font-inter">{language && language?.["Save"] ? language?.["Save"] : "Save"}</p>
                </button>
            </div>
        </div>
    )
}
export default LocationCompany